import {
  SETTEXT,
  SETPHONEMESSAGE,
  SETSMSMESSAGE,
  SETEMAILMESSAGE,
} from './actionType'

export function setText(data) {
  return {
    type: SETTEXT,
    data: data,
  }
}
export function setPhoneMessage(data) {
  return {
    type: SETPHONEMESSAGE,
    data: data,
  }
}
export function setSMSMessage(data) {
  return {
    type: SETSMSMESSAGE,
    data: data,
  }
}
export function setEmailMessage(data) {
  return {
    type: SETEMAILMESSAGE,
    data: data,
  }
}
